exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".contact {\n  padding-left: 10px;\n  padding-right: 10px;\n  position: relative;\n  text-align: center;\n}\n\n.contactTitle {\n  margin-bottom: 40px;\n}\n", ""]);

